export default "__VITE_ASSET__mfYW$FGX__"